import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { NOINDEX_ROUTES } from "../../utils/seoDefaults";

export default function RouteRobots() {
  const location = useLocation();
  const shouldNoIndex = NOINDEX_ROUTES.some((path) =>
    location.pathname.startsWith(path)
  );
  const robotsContent = shouldNoIndex ? "noindex,nofollow" : "index,follow";
  const googleBotContent = shouldNoIndex
    ? "noindex,nofollow"
    : "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1";

  return (
    <Helmet>
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={googleBotContent} />
    </Helmet>
  );
}
